import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { orderExtended } from './store'

export const OrderModuleExtended: StorefrontModule = function ({ store }) {
  store.registerModule('store', orderExtended)
}
